import { render, staticRenderFns } from "./BasePanel.vue?vue&type=template&id=a5af6f50&"
import script from "./BasePanel.vue?vue&type=script&lang=js&"
export * from "./BasePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports